import { render, staticRenderFns } from "./ProductHistoryItem.vue?vue&type=template&id=50e12c76&scoped=true"
import script from "./ProductHistoryItem.vue?vue&type=script&lang=js"
export * from "./ProductHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./ProductHistoryItem.vue?vue&type=style&index=0&id=50e12c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e12c76",
  null
  
)

export default component.exports